<script>
export default {}
</script>

<template>
  <div class="columns">
    <div class="column">
      <slot></slot>
    </div>
    <div class="column">
      <b-field grouped position="is-right">
        <b-input v-model="$parent.searchQuery" icon="magnify" type="text" placeholder="Search"></b-input>
      </b-field>
    </div>
  </div>
</template>

<style lang="scss">
</style>